import { DateTime } from '@ksyos/date-time';
import type { IService, IServiceOrganizationSettings } from '@common/interfaces/';

export function initializeServiceOrganizationSettings(service: IService): IServiceOrganizationSettings {
    return {
        applicationWaitingTime: null,
        canPerformGlaucoomExamination: null,
        canReferPatientWithoutSmartphone: service.code === 'OSAS',
        emailAddressOrganizationInbox: null,
        emailAddressOrganizationInboxAlt: null,
        embloomQuestionnaires: undefined,
        endDate: null,
        isRequestRecipient: false,
        ksyosHolterAnalystOrganizationId: null,
        optoConnectPracticeId: null,
        receiveZorgmailOnConsultOpen: false,
        recipientIsOwnOrganization: false,
        sendBittiumRecordingsTo: null,
        sendNotificationOrganizationEmail: false,
        sendNotificationOrganizationInbox: false,
        service,
        serviceGraderPoolId: null,
        serviceGroupSetting: null,
        serviceGroupSettingId: null,
        serviceId: service.id,
        somnologyOrganizationType: null,
        startDate: DateTime.now().format('YYYY-MM-DD'),
        treatmentWaitingTime: null,
        zorgmailNummer: null,
    };
}
